import type { ColumnsType } from "antd/es/table";
import { Button } from "antd";
import { langPage, langTableColumns } from "../../../locales";
import { FormConfigType } from "../../../components/editForm";
import dayjs from 'dayjs';

export const DEFAULT_QUERY_DATA = {
    CardNumber: null,
    IsActive: null,
    UdpayCardStatus: null
};

export const generateQueryFormConfig = (props: any): FormConfigType => {
    const { options: { isActiveOptions, udpayCardStatusOptions } } = props;
    return [
        {
            title: '卡号',
            type: "input",
            field: "CardNumber",
            allowClear: true,
        },
        {
            title: "是否已激活",
            type: "select",
            field: "IsActive",
            allowClear: true,
            options: isActiveOptions,
        },
        {
            title: "卡片状态",
            type: "select",
            field: "UdpayCardStatus",
            allowClear: true,
            options: udpayCardStatusOptions,
        },
    ];
}

export const generateTableColumns = (props: any): ColumnsType => {
    const { loading, operationRef} = props;
    return [
        {
            title: 'id',
            dataIndex: "Id",
        },
        {
            title: '卡头',
            dataIndex: "UdpayCardBin",
        },
        {
            title: '遮罩卡号',
            dataIndex: "UdpayMaskedCardNumber",
        },
        {
            title: '卡号',
            dataIndex: "UdpayCardNumber",
        },
        {
            title: 'cvv',
            dataIndex: "UdpayCvv",
        },
        {
            title: '过期时间',
            dataIndex: "UdpayExpireDate",
        },
        {
            title: '状态',
            dataIndex: "UdpayCardStatus",
        },
        {
            title: '激活时间',
            dataIndex: "ActiveTimeString",
        },
        {
            title: '三方持卡人id',
            dataIndex: "UdpayCardholderId",
        },
        {
            title: '三方卡id',
            dataIndex: "UdpayCardId",
        },
        {
            title: '创建时间',
            dataIndex: "CreatedAtString",
        },
    ]
}